export default __webpack_public_path__ + "static/media/logo-wide.89afa718.png";